var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"empty"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"empty-img"},[_c('img',{attrs:{"src":_vm.NoData,"alt":""}})]),_c('div',{staticClass:"empty-text"},[_vm._v(" 内容已下架或者不存在 ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }